import { useState } from "react";
import { Loader } from "semantic-ui-react";

import { NoteSuggestionsModal, NoteSuggestionsTable } from "modules/NoteSuggestions/components";
import { useNoteTypesWithSuggestionsQuery } from "modules/NoteSuggestions/hooks";

import type { NOTE_SUGGESTION_TYPES } from "models";

export const NoteSuggestions = () => {
  const [openedModalNoteType, setOpenedNoteTypeModal] = useState<NOTE_SUGGESTION_TYPES | null>(null);

  const { noteTypesWithSuggestions, isLoadingNoteSuggestionTypes } = useNoteTypesWithSuggestionsQuery();

  const openModal = (type: NOTE_SUGGESTION_TYPES) => setOpenedNoteTypeModal(type);
  const closeModal = () => setOpenedNoteTypeModal(null);

  if (isLoadingNoteSuggestionTypes) return <Loader active />;

  return (
    <>
      <NoteSuggestionsTable openModal={openModal} noteTypesWithSuggestions={noteTypesWithSuggestions} />
      <NoteSuggestionsModal closeModal={closeModal} openedModalNoteType={openedModalNoteType} noteTypesWithSuggestions={noteTypesWithSuggestions} />
    </>
  );
};
